<template>
  <div class="barometer-inner-wrapper">
    <div class="barometer-inner-header">
      <h2>Omzet</h2>
      <!-- <h2>{{employeeNameArray[0]}}</h2>
      <h3>Week {{weeknr}}</h3>-->
    </div>
    <div class="barometer-canvas-wrapper">
      <canvas
        :id="canvasID"
        generateGradient="false"
        width="220"
        height="120"
      ></canvas>
    </div>
    <div class="barometer-footer">
      <div class="barometer-rate ma-0">
        <span v-if="actualPercentage > 100" class="on-fire"></span>
        <!-- <div v-if="!hourRateAmmount">{{actualPercentage}}%</div> -->
        <div>
          <span>€ {{ actualPercentage }}</span>

          <!-- <span v-if="employeeTarget" style="font-size:12px">
            &nbsp;{{(100 * rate) /
            employeeTarget.revenue | roundmeFilter
            }}%
          </span> -->
        </div>
      </div>
      <p v-if="revenue" class="barometer-description">
        <!-- De doelstelling is om boven de 100% te blijven -->
      </p>
      <div v-else class="barometer-alert">
        <v-alert :value="true" type="warning"
          >Er is nog geen doel ingesteld.</v-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../../firebase/init";
import { bus } from "../../main";
import { log } from "util";
export default {
  props: [
    "level",
    "marks",
    "aperture",
    "colorStop",
    "colorStart",
    "canvasID",
    "rate",
    "employeeName",
    "employeeTarget",
    "weeknr",
    "hourRateAmmount",
  ],
  name: "employeerBarometer",
  data: () => ({
    mini: true,
    employeeNameArray: [],
    id: null, //passed getal door
    width: 220,
    canvasRender: null,
    actualPercentage: null, //Status Barometer employee
    revenue: null,
    opts: {
      angle: -0.1, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676",
      },
      colorStop: "#333",
      colorStart: "#333",
      strokeColor: "rgb(204,204,204)",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      // generateGradient: true,
      highDpiSupport: true,

      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],
      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      },
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    },
  }),

  created() {
    bus.$on("employeeBarometerUpdate", this.updateData);
    this.opts.colorStop = this.colorStop;
  },

  mounted() {
    this.updateData();
  },

  filters: {
    roundmeFilter(value) {
      return value.toFixed(1); // thing to transform
    },
  },

  methods: {
    updateData() {
      let theMaxValue = 120;
      const splitEmployeeName = this.employeeName.split(" ");
      this.employeeNameArray = splitEmployeeName;

      if (this.employeeTarget) {
        if (this.employeeTarget.revenue) {
          theMaxValue = this.employeeTarget.revenue + 20;
          this.revenue = this.employeeTarget.revenue;
          this.actualPercentage = this.employeeTarget.revenue.toFixed(1);

          // if (this.hourRateAmmount == true) {
          //   this.opts.staticLabels.labels = [];
          //   this.opts.staticLabels.labels.push(this.employeeTarget.revenue);
          //   theMaxValue = this.employeeTarget.revenue + 20;
          //   this.actualPercentage = this.rate.toFixed(2);
          // }
          // else {
          //   theMaxValue = 120;
          //   this.actualPercentage = ((this.employeeTarget.revenue / (this.employeeTarget.fourweekrevenue / 4)) * 100).toFixed(1);
          // }
        } else if (this.rate > 0) {
          this.revenue = this.employeeTarget.revenue;
          this.actualPercentage = 0;
        } else {
          this.actualPercentage = 0;
          this.revenue = null;
        }
      } else {
        this.actualPercentage = 0;
        this.revenue = null;
      }

      var opts = this.opts;
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(opts); // Unieke Gauge opbouwn

      gauge.maxValue = theMaxValue; // max gauge value
      gauge.setMinValue(0); // min value
      gauge.set(this.actualPercentage); // actual valu0;
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    // intel() {
    //   if (this.revenue == null) {
    //     return `<span style="">Er is nog geen doel voor deze medewerker ingesteld.</span>`;
    //     // return `<span style="">Er is nog geen doel voor ${this.employeeName} ingesteld.</span>`;
    //   } else {
    //     return `<span style="red">De doelstelling is om boven de 100% te blijven.</span>`;
    //     // return `<span style="red">De doelstelling voor ${this.employeeName} is rond de 100% te blijven.</span>`;
    //   }
    // }
  },
};
</script>
